import { PayoutStatus } from '@nemuru-eng/js-api-client';
import React from 'react';

import { StatusTagType } from '../../../../../config/types';
import { StatusTag } from '../StatusTag';

export const PayoutStatusTag: React.FC<{ status: PayoutStatus }> = ({ status }) => {
  const getStatusTagProps = (): React.ComponentProps<typeof StatusTag> => {
    switch (status) {
      case PayoutStatus.DISBURSED:
        return {
          type: StatusTagType.SUCCESS,
          labelTextId: 'DISBURSED',
          colorType: 'main',
        };
      case PayoutStatus.PUBLISHED:
        return {
          type: StatusTagType.SUCCESS,
          labelTextId: 'PUBLISHED',
          colorType: 'dark',
        };
      case PayoutStatus.IN_REVIEW:
        return {
          type: StatusTagType.WARNING,
          labelTextId: 'IN_REVIEW',
          colorType: 'main',
        };
      case PayoutStatus.PUBLISHING:
        return {
          type: StatusTagType.INFO,
          labelTextId: 'PUBLISHING',
          colorType: 'main',
        };
    }
  };

  const statusTagProps = getStatusTagProps();
  return <StatusTag {...statusTagProps} />;
};
